import * as React from 'react';
import { LogoNav, Logout, ArrowDropRight } from '../assets/svg-icons'
import Routes from '../constants/Routes'
import '../styles/ScrollBar.css'
import { Link, matchPath, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSession } from 'src/features/auth';
import { useGetCurrentMemberQuery } from 'src/graphql';
import avatar_placeholder from 'src/assets/images/avatar-placeholder.png'

const SIDE_BAR_ROUTES = Routes.filter((r) => !r.hideFromMenu)

const Sidebar: React.FC<{ currentRoute: string }> = () => {

    const auth = useSession()
    const { data } = useGetCurrentMemberQuery();
    const { t } = useTranslation();

    const location = useLocation();
    return (
        <div className='flex flex-col bg-dark justify-between text-dark-primary h-screen font-Poppins relative p-1'>
            <div className='flex justify-center'>
                <img src={LogoNav} alt='logo' className='lg:h-28 max-lg:h-20' />
            </div>

            <div className='flex flex-col h-full maxlg:justify-center hide-scrollbar overflow-y-auto'>
                {SIDE_BAR_ROUTES.map((route, index) => {
                    const Icon = route.icon;
                    const selected = matchPath(location.pathname, route.href);
                    return (
                        <Link
                            to={route.href}
                            key={route.label}
                            className={`text-sm font-normal relative p-3 hover:bg-light/10 rounded ${selected && 'bg-light/10'}`}
                        >
                            {selected && <div className='absolute -left-3 top-1'>
                                <ArrowDropRight className='text-blue w-10 h-10' />
                            </div>}
                            <div className={`flex group max-lg:flex-col gap-x-3 items-center cursor-pointer lg:ms-6
                            ${selected && 'text-blue'}
                            `}>
                                <Icon className="h-6 w-6" />
                                <div className=' max-lg:hidden'>
                                    {t(route.label)}
                                </div>
                            </div>
                        </Link>
                    );
                })}
            </div>

            <hr className="border-[#3D3D3D] mx-4 my-1" />


            <div className=' flex flex-col'>
                {/*Button*/}
                <Link to='/my-profile' className='flex w-full  rounded hover:bg-light/10'>
                    <button className='flex items-center gap-x-2 p-3 md:ps-[20px] lg:ps-[35px]'>
                        <img
                            src={avatar_placeholder}
                            alt='profile'
                            className='w-7 h-7 border-2 border-blue rounded-full object-contain ' />
                        <p className='text-sm font-normal max-lg:hidden'>{data?.getCurrentMember?.name}</p>
                    </button>
                </Link>

                {/*Button*/}
                <button onClick={() => auth.signOut()} className='flex items-center gap-x-3 p-3 rounded md:ps-[20px] lg:ps-[35px] hover:bg-light/10'>
                    <img
                        src={Logout}
                        alt='profile'
                        className='w-6 h-6' />
                    <p className='text-sm font-normal max-lg:hidden'>{t("logout")}</p>
                </button>
            </div>
        </div>
    )
}

export default Sidebar